import { hideElement, setElementHtml } from '../../../../../helpers/generic-js/dom.js'
import { addListeners } from './add-listeners.js'

export function showTokenInfo (params) {
  const { containerElementId, tokenSetInfo, apiTokenResponse } = params

  if (!apiTokenResponse) {
    hideElement(containerElementId)
    return
  }

  if (!tokenSetInfo) {
    hideElement(containerElementId)
    return
  }

  if (!apiTokenResponse.tenants || apiTokenResponse.tenants.length === 0) {
    hideElement(containerElementId)
    return
  }

  const html = `
    <div>
      <b>Token Info</b>
      <p><b>Id:</b> ${tokenSetInfo.id_token}</p>
      <p><b>Token:</b> ${tokenSetInfo.access_token}</p>
      <p><b>Scope:</b> ${tokenSetInfo.scope}</p>
      <p><b>Expired?</b> ${tokenSetInfo.isExpired}</p>
      <p><b>Expires at:</b> ${tokenSetInfo.expires_at}</p>
      <button class="button is-primary is-light" data-action="refresh-token">Refresh Token</button>
      <button class="button is-danger is-light" data-action="revoke-token">Disconnect Xero</button>
    </div>
  `

  const containerElement = setElementHtml(containerElementId, html)
  if (!containerElement) return

  addListeners(containerElement, tokenSetInfo, params.callbacks)
}
